import { useState } from "react";
import Reveal from "@/components/feature/Reveal";
import SectionTitle from "@/components/feature/SectionTitle";
import { faqs } from "@/mocks/faq";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="site-container">
        <Reveal>
          <SectionTitle
            upper="FAQ"
            under="初めてご利用の方からよくいただくご質問をまとめました。"
          >
            よくあるご質問
          </SectionTitle>
        </Reveal>

        <div className="mx-auto mt-12 max-w-3xl space-y-3">
          {faqs.map((f, i) => (
            <Reveal key={f.q} delay={i * 40}>
              <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100/70">
                <button
                  type="button"
                  onClick={() => setOpen(open === i ? null : i)}
                  className="flex w-full cursor-pointer items-center gap-3 p-4 text-left"
                >
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-black text-background-50">
                    Q
                  </span>
                  <span className="flex-1 text-base font-bold text-foreground-900">{f.q}</span>
                  <i className={`${open === i ? "ri-subtract-line" : "ri-add-line"} text-lg text-primary-600`} />
                </button>
                {open === i ? (
                  <div className="flex gap-3 border-t border-background-200 bg-background-50 p-4">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-500 font-heading text-sm font-black text-background-50">
                      A
                    </span>
                    <p className="text-base leading-relaxed text-foreground-700">{f.a}</p>
                  </div>
                ) : null}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}